import { bool, shape, string } from "prop-types";
import { LineItemShape } from "shared/components/configurator/roomBook.shape";

export const ConfiguratorLineItemShape = shape({
  ...LineItemShape,
  status: shape({
    id: string,
    label: string,
    color: string,
    selectable: bool
  }),
  isRequired: bool
});

export default ConfiguratorLineItemShape;
